import config from '~/Config';

const BETA_MONTHLY = {
  plan: 'MONTHLY',
  price: 3,
  displayPrice: '3',
  displayUnits: '/MONTH',
  subtext: 'Normally $5/month',
  billingCycle: 'monthly',
  displayName: 'Beta (Grandfathered)',
  commonIdentifier: 'MONTHLY',
};
const BETA_YEARLY = {
  plan: 'YEARLY',
  price: 30,
  displayPrice: '30',
  displayUnits: '/YEAR',
  subtext: 'Normally $50/year',
  billingCycle: 'yearly',
  displayName: 'Beta (Grandfathered)',
  commonIdentifier: 'YEARLY',
};
const EA_MONTHLY = {
  plan: 'EA_MONTHLY',
  price: 3.99,
  displayPrice: '3.99',
  displayUnits: '/MONTH',
  subtext: 'billed monthly',
  billingCycle: 'monthly',
  iapSku: 'ea_monthly',
  displayName: 'Early Access (Grandfathered)',
  commonIdentifier: 'EA_MONTHLY',
};
const EA_YEARLY = {
  plan: 'EA_YEARLY',
  price: 35,
  displayPrice: '2.92',
  displayUnits: '/MONTH',
  subtext: '$35 billed annually',
  starburst: 'SAVE $12.88!',
  billingCycle: 'yearly',
  iapSku: 'ea_yearly',
  displayName: 'Early Access (Grandfathered)',
  commonIdentifier: 'EA_YEARLY',
};
const YEARLY = {
  plan: config.pricingPlans.yearlyWithTrial,
  price: 34.99,
  displayPrice: '2.92',
  displayUnits: '/MONTH',
  subtext: '$34.99 billed annually',
  billingCycle: 'yearly',
  iapSku: 'yearly_with_trial',
  displayName: 'Artful Agenda (Grandfathered)',
  commonIdentifier: 'yearly_with_trial',
};
const AB_TEST_A = {
  plan: config.pricingPlans.yearlyWithTrialA,
  price: 39.99,
  displayPrice: '3.33',
  displayUnits: '/MONTH',
  subtext: '$39.99 billed annually',
  billingCycle: 'yearly',
  iapSku: 'yearly_w_trial_a',
  displayName: 'Artful Agenda',
  commonIdentifier: 'yearly_w_trial_a',
};
const AB_TEST_B = {
  plan: config.pricingPlans.yearlyWithTrialB,
  price: 44.99,
  displayPrice: '3.75',
  displayUnits: '/MONTH',
  subtext: '$44.99 billed annually',
  billingCycle: 'yearly',
  iapSku: 'yearly_w_trial_b',
  displayName: 'Artful Agenda (Grandfathered)',
  commonIdentifier: 'yearly_w_trial_b',
};
const YEARLY_PLUS = {
  plan: config.pricingPlans.yearlyPlus,
  price: 49.99,
  displayPrice: '4.17',
  displayUnits: '/MONTH',
  subtext: '$49.99 billed annually',
  billingCycle: 'yearly',
  iapSku: 'yearly_plus_w_trial',
  displayName: 'Artful Plus',
  commonIdentifier: 'yearly_plus',
};
const LIFETIME_PLUS_INITIAL = {
  plan: config.pricingPlans.lifetimePlusInitial,
  price: 125,
  displayPrice: '125',
  displayUnits: '/LIFETIME',
  subtext: '$125 billed once',
  billingCycle: 'once',
  iapSku: 'lifetime_plus_initial',
  displayName: 'Lifetime Plus',
  commonIdentifier: 'lifetime_plus_initial',
  isLifetime: true,
};

const LIFETIME_PLUS_RENEWAL = {
  plan: config.pricingPlans.lifetimePlusRenewal,
  price: 0,
  displayPrice: '125',
  displayUnits: '/LIFETIME',
  subtext: '$125 billed once',
  billingCycle: 'once',
  iapSku: 'lifetime_plus_renewal',
  displayName: 'Lifetime Plus',
  commonIdentifier: 'lifetime_plus_renewal',
  isLifetime: true,
};

export const getPricing = () => {
  return {
    yearly: AB_TEST_A,
    yearlyPlus: YEARLY_PLUS,

    // legacy plans
    betaMonthly: BETA_MONTHLY,
    betaYearly: BETA_YEARLY,
    eaMonthly: EA_MONTHLY,
    eaYearly: EA_YEARLY,
    legacyYearly: YEARLY,
    yearlyABTestA: AB_TEST_A,
    yearlyABTestB: AB_TEST_B,

    // lifetime plans
    lifetimePlusInitial: LIFETIME_PLUS_INITIAL,
    lifetimePlusRenewal: LIFETIME_PLUS_RENEWAL,
  };
};

export const getLockInText = () => {
  return '';
};

export const planMatchesIap = (plan, iapSku) => {
  return (
    plan?.iapSku &&
    iapSku &&
    [
      plan.iapSku,
      `${plan.iapSku}.staging`,
      `${plan.iapSku}_w_trial`,
      `${plan.iapSku}_w_trial.staging`,
    ].includes(iapSku)
  );
};

export const isLifetimePlan = activePlanName => {
  const activePlan = Object.values(getPricing()).find(
    ({ plan, commonIdentifier }) => plan == activePlanName || commonIdentifier == activePlanName
  );
  return !!activePlan?.isLifetime;
};

export const getPlanFromIdentifier = activePlanIdentifier => {
  const activePlan = Object.values(getPricing()).find(
    ({ plan, commonIdentifier }) =>
      plan == activePlanIdentifier || commonIdentifier == activePlanIdentifier
  );
  return activePlan;
};
